// extracted by mini-css-extract-plugin
module.exports = {"scan-area":"ScanField_scan-area_bmidu","scanArea":"ScanField_scan-area_bmidu"};